(function () {
  'use strict';

  var MESSAGE_SELECTOR = '[data-paypal-pay-later-message]';
  var PAYPAL_MESSAGE_SELECTOR = '[data-pp-message]';
  var SDK_FLAG_SELECTOR = 'script[data-paypal-pay-later-sdk]';
  var COUNTRY_API_URL = 'https://api.country.is/';
  var sdkPromise = null;

  function normalizeCountryList(value) {
    return String(value || '')
      .split(/[,\s]+/)
      .map(function (countryCode) {
        return countryCode.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function shouldShowPaypalPayLater(countryCode, allowedCountries) {
    var normalizedCountryCode = String(countryCode || '').trim().toUpperCase();
    var allowedCountryList = Array.isArray(allowedCountries)
      ? allowedCountries
      : normalizeCountryList(allowedCountries);

    return normalizedCountryCode !== '' && allowedCountryList.indexOf(normalizedCountryCode) !== -1;
  }

  function getDetectedCountryCode(data) {
    if (!data || !data.country) {
      return '';
    }

    return String(data.country || '').trim().toUpperCase();
  }

  function fetchDetectedCountryCode() {
    if (!window.fetch) {
      return Promise.resolve('');
    }

    return window.fetch(COUNTRY_API_URL, { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to load IP country');
        }

        return response.json();
      })
      .then(getDetectedCountryCode);
  }

  function buildPaypalSdkUrl(clientId) {
    return 'https://www.paypal.com/sdk/js?client-id='
      + encodeURIComponent(clientId)
      + '&currency=USD&components=messages';
  }

  function loadPaypalSdk(clientId) {
    if (window.paypal && window.paypal.Messages) {
      return Promise.resolve();
    }

    if (sdkPromise) {
      return sdkPromise;
    }

    sdkPromise = new Promise(function (resolve, reject) {
      var existingScript = document.querySelector(SDK_FLAG_SELECTOR);

      if (existingScript) {
        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = buildPaypalSdkUrl(clientId);
      script.defer = true;
      script.dataset.paypalPayLaterSdk = 'true';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return sdkPromise;
  }

  function setAttributeIfPresent(element, name, value) {
    if (value !== undefined && value !== null && String(value) !== '') {
      element.setAttribute(name, value);
    }
  }

  function getPaypalMessageTarget(messageWrapper) {
    var existingTarget = messageWrapper.querySelector(PAYPAL_MESSAGE_SELECTOR);
    var messageTarget = existingTarget || document.createElement('div');

    if (!existingTarget) {
      messageTarget.setAttribute('data-pp-message', '');
      messageTarget.setAttribute('data-pp-style-layout', 'text');
      messageTarget.setAttribute('data-pp-style-logo-type', 'inline');
      messageTarget.setAttribute('data-pp-style-text-color', 'black');
      messageTarget.setAttribute('data-pp-style-text-size', '12');
      setAttributeIfPresent(messageTarget, 'data-pp-amount', messageWrapper.dataset.paypalAmount);
      setAttributeIfPresent(messageTarget, 'data-pp-placement', messageWrapper.dataset.paypalPlacement);
      setAttributeIfPresent(messageTarget, 'data-pp-buyercountry', messageWrapper.dataset.paypalBuyerCountry);
      messageWrapper.appendChild(messageTarget);
    }

    return messageTarget;
  }

  function preparePaypalMessageWrappers(messageWrappers) {
    messageWrappers.forEach(function (messageWrapper) {
      messageWrapper.hidden = false;
      messageWrapper.style.visibility = 'hidden';
    });
  }

  function showPaypalMessageWrappers(messageWrappers) {
    messageWrappers.forEach(function (messageWrapper) {
      messageWrapper.style.visibility = '';
      messageWrapper.dataset.paypalPayLaterRendered = 'true';
    });
  }

  function hidePaypalMessageWrappers(messageWrappers) {
    messageWrappers.forEach(function (messageWrapper) {
      messageWrapper.hidden = true;
      messageWrapper.style.visibility = '';
    });
  }

  function renderPaypalMessages(messageWrappers) {
    var messageTargets = [];
    var pendingWrappers = [];
    var renderResult = null;

    messageWrappers.forEach(function (messageWrapper) {
      if (messageWrapper.dataset.paypalPayLaterRendered === 'true') {
        return;
      }

      messageTargets.push(getPaypalMessageTarget(messageWrapper));
      pendingWrappers.push(messageWrapper);
    });

    if (!messageTargets.length || !window.paypal || !window.paypal.Messages) {
      return Promise.resolve(false);
    }

    preparePaypalMessageWrappers(pendingWrappers);

    try {
      renderResult = window.paypal.Messages().render(messageTargets);
    } catch (error) {
      hidePaypalMessageWrappers(pendingWrappers);
      return Promise.resolve(false);
    }

    return Promise.resolve(renderResult)
      .then(function () {
        showPaypalMessageWrappers(pendingWrappers);
        return true;
      })
      .catch(function () {
        hidePaypalMessageWrappers(pendingWrappers);
        return false;
      });
  }

  function getMessageWrappers(root) {
    var searchRoot = root && root.querySelectorAll ? root : document;
    return Array.prototype.slice.call(searchRoot.querySelectorAll(MESSAGE_SELECTOR));
  }

  function init(root) {
    var messageWrappers = getMessageWrappers(root);

    if (!messageWrappers.length) {
      return Promise.resolve(false);
    }

    return fetchDetectedCountryCode()
      .then(function (countryCode) {
        var eligibleWrappers = messageWrappers.filter(function (messageWrapper) {
          return shouldShowPaypalPayLater(
            countryCode,
            messageWrapper.dataset.paypalAllowedCountries
          );
        });
        var clientId = eligibleWrappers[0] && eligibleWrappers[0].dataset.paypalClientId;

        if (!eligibleWrappers.length || !clientId) {
          return false;
        }

        return loadPaypalSdk(clientId).then(function () {
          return renderPaypalMessages(eligibleWrappers);
        });
      })
      .catch(function () {
        return false;
      });
  }

  window.EcowittPaypalPayLater = {
    init: init,
    normalizeCountryList: normalizeCountryList,
    shouldShowPaypalPayLater: shouldShowPaypalPayLater
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
